import React from "react";
import { colors } from "components/card/colors";
import { motion } from "framer-motion";

const subjects = [
  { value: "Պատմություն", label: "Պատմություն" },
  { value: "Աշխարհագրություն", label: "Աշխարհագրություն" },
  { value: "Հայոց Լեզու", label: "Հայոց Լեզու" },
  { value: "Իմ Հայրենիքը", label: "Իմ Հայրենիքը" },
];

const lessonClasses = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
];

const LessonsFilters = ({ filters, setFilters }) => {
  return (
    <div className="px-8 pt-10">
      <motion.div
        className="flex flex-col gap-4 items-center md:items-start"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="flex hidden md:flex items-center gap-4 rounded-[46px] px-[24px] py-[14px] w-fit"
          style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
        >
          <span className="text-[20px] font-[500] text-[#212121]">Դասարան</span>
          {lessonClasses.map((cls) => {
            return (
              <div
                key={cls}
                className={`h-[46px] w-[46px] rounded-full flex items-center justify-center cursor-pointer ${
                  filters.lessonClass?.includes(cls)
                    ? "opacity-100 border-2 border-gray-200"
                    : "opacity-50"
                }`}
                onClick={() =>
                  setFilters((prev) =>
                    prev.lessonClass?.includes(cls)
                      ? {
                          ...prev,
                          lessonClass: prev.lessonClass.filter(
                            (i) => i !== cls
                          ),
                        }
                      : {
                          ...prev,
                          lessonClass: [...(prev.lessonClass || []), cls],
                        }
                  )
                }
                style={{
                  backgroundColor: colors[cls],
                }}
              >
                <span className="text-[14px] font-[900]">{cls}</span>
              </div>
            );
          })}
        </motion.div>
        <motion.div
          className="flex flex-col md:flex-row items-center justify-center gap-4 rounded-[46px] px-[24px] py-[14px] w-fit"
          style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {subjects.map((subject) => {
            return (
              <motion.div
                key={subject.value}
                className="w-fit rounded-[20px] flex items-center justify-center px-[12px] py-[8px] cursor-pointer"
                style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
                onClick={() =>
                  setFilters((prev) =>
                    prev.subject === subject.value
                      ? { ...prev, subject: "" }
                      : { ...prev, subject: subject.value }
                  )
                }
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 0px 15px rgba(0,0,0,0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div
                  className={`w-[22px] h-[22px] rounded-[33px] border-[4px] mr-2`}
                  style={{
                    backgroundColor:
                      filters.subject === subject.value
                        ? colors[subject.value]
                        : "white",
                    borderColor:
                      filters.subject === subject.value
                        ? "white"
                        : colors[subject.value],
                  }}
                />
                <span className="text-[16px] font-[500]">{subject.label}</span>
              </motion.div>
            );
          })}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LessonsFilters;
